import { Toast } from "@heroui/react";
import { useEffect } from "react";
import { useAppSelector } from "@/src/common/redux/store";
import { getColorScheme, getVariant } from "@/src/common/store/general-selectors";

export function AppThemeProvider({ children }: { children: React.ReactNode }) {
	const colorScheme = useAppSelector(getColorScheme);
	const variant = useAppSelector(getVariant);

	useEffect(() => {
		const root = document.documentElement;
		root.classList.remove("light", "dark");
		root.classList.add(colorScheme);
		root.setAttribute("data-theme", colorScheme);
	}, [colorScheme]);

	useEffect(() => {
		document.documentElement.setAttribute("data-variant", variant);
	}, [variant]);

	return (
		<>
			{children}
			<Toast.Provider />
		</>
	);
}
